module.exports = __webpack_public_path__ + "static/media/filter-icon.92830abf.svg";